export default "__VITE_ASSET__CwWadOW3__"